<template>
	<div>
		<CubePage type="myorder-view" title="数据概括">
			<div slot="content" class="content">
				<div class="main" v-if="listObj != null">
					<div class="header-title">
						<h1>智慧旅业网游客大数据平台</h1>
						<h3>{{listObj.title}}</h3>
					</div>
					<div class="datalist">
						<div class="ii"> 购票人数 <span>{{listObj.order_total}}</span> 人 </div>
						<div class="ii"> 已 入 园 <span>{{listObj.use_total}}</span> 人 </div>
						<div class="ii"> 待 入 园 <span>{{listObj.wait_total}}</span> 人 </div>
					</div>
					<div class="wl">
						<p>未来10天游客预定人数</p>
						<div class="scroll">
							<div class="flex" v-for=" (item,i) in listObj.lists" :key="i">
								<div class="l-date">
									{{i}}
								</div>
								<div class="r-num">
									{{item}}人
								</div>
							</div>
						</div>
					</div>
					<div class="tbox datalist">
						<div id="kypre" ref="kypre" style="width: 100%;height:120px;"></div>
						<div class="tbox-list">
							<div class="flex " v-for=" (item,index) in kyList" :key="index">
								<div class="l-date">
									{{item.name}}
								</div>
								<div class="r-num">
									{{item.value}}人
								</div>
							</div>
						</div>
					</div>
					<div class="wl datalist">
						<p>客源地前十</p>
						<div class="scroll">
							<div v-if="listObjKy.length>0">
								<div class="flex" v-for=" (item,i) in listObjKy" :key="i">
									<div class="l-date">
										{{item.name}}
									</div>
									<div class="r-num">
										{{item.value}}人
									</div>
								</div>
							</div>
							<div class="no-data" v-else>
								暂无数据
							</div>
						</div>
					</div>
					<div class="tbox datalist">
						<div id="mainPre" ref="mainPre" style="width: 100%;height:120px;"></div>
						<div class="tbox-list">
							<div class="flex " v-for=" (item,index) in listAgeObj" :key="index">
								<div class="l-date">
									{{item.name}}
								</div>
								<div class="r-num">
									{{item.value}}人
								</div>
							</div>
						</div>
					</div>
					<div class="datalist">
						<div id="agePre" ref="agePre" style="width: 100%;height:120px;"></div>
					</div>
					<div class="datalist">
						<div id="agesPre" ref="agesPre" style="width: 100%;height:220px;"></div>
					</div>
					<div class="datalist">
						<div id="agesBar" ref="agesBar" style="width: 100%;height:180px;"></div>
					</div>
				</div>


			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import * as echarts from 'echarts';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				listObj: null,
				listObjKy: [],
				kyList: [],
				listAgeObj: []
			}
		},
		created() {},
		mounted() {
			this.initht()
			this.onSearch()
			this.onYSearch()
			this.ageSearch()
			this.onAgeSearch()
			this.onNSearch()
		},
		methods: {
			initht() {
				this.$nextTick(() => {
					this.onKySearch()
					// this.initBt()
				})
			},
			onSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/data_summary"
				//这里直接调用网络接口
				util.post(url, {},
					function (result) {
						that.listObj = result.data
					},
				);
			},
			async onKySearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getChannelGroupList"
				//这里直接调用网络接口
				await util.post(url, {},
					function (result) {
						setTimeout(() => {
							that.kyList = result.data.list
							that.initKyBt(result.data.list)
						}, 800)
					},
				);
			},
			async onYSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getSourceGroupList"
				//这里直接调用网络接口
				await util.post(url, {},
					function (result) {
						that.listObjKy = result.data.list
					},
				);
			},
			initKyBt(data) {
				var myChart = echarts.init(this.$refs.kypre);
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '团散比',
						left: 'center',
						textStyle: {
							color: '#00ffff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center',
						show: false
					},
					series: [{
						top: 20,
						name: '团散比',
						type: 'pie',
						radius: ['30%', '50%'],
						avoidLabelOverlap: false,
						data: data,
						label: {
							color: '#fff',
							formatter: `{b}\n{d}%`,
						}
					}]
				};
				option && myChart.setOption(option);
				this.$nextTick(() => {
					window.onresize = function () {
						myChart.resize()
					}
				})
			},
			initBt(data) {
				var myChart = echarts.init(this.$refs.mainPre);
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '游客年龄段',
						left: 'center',
						textStyle: {
							color: '#00ffff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center',
						show: false
					},
					series: [{
						top: 25,
						name: '游客年龄段',
						type: 'pie',
						radius: ['30%', '50%'],
						avoidLabelOverlap: false,
						data: data,
						label: {
							color: '#fff',
							formatter: `{b}\n{d}%`,
						}
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function () {
					myChart.resize()
				}
			},
			initAge(data) {
				var myChart = echarts.init(this.$refs.agePre);
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '游客男女比例',
						left: 'center',
						textStyle: {
							color: '#00ffff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center',
						show: false
					},
					series: [{
						top: 20,
						name: '游客年龄段',
						type: 'pie',
						radius: '50%',
						avoidLabelOverlap: false,
						data: data,
						label: {
							color: '#fff',
							formatter: `{b}\n{d}%`,
						}
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function () {
					myChart.resize()
				}
			},
			initAges(data) {
				var myChart = echarts.init(this.$refs.agesPre);
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '游客年龄段',
						left: 'center',
						textStyle: {
							color: '#00ffff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						right: 5,
						bottom: 5,
						itemWidth: 5,
						itemHeight: 5,
						textStyle: {
							color: '#fff'
						}
					},
					series: [{
						top: 20,
						name: '游客年龄段',
						type: 'pie',
						radius: '80%',
						right: '100',
						data: data,
						label: {
							position: 'inner',
							formatter: `{d}%`,
							color: '#fff'
						}
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function () {
					myChart.resize()
				}
			},
			initBar(data) {
				var myChart = echarts.init(this.$refs.agesBar);
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '游客年龄',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff'
					},
					xAxis: {
						type: 'category',
						data: data.groups,
						axisLabel: {
							color: '#fff',
							rotate: 40
							// formatter: function(value) {
							// 	let b=value.substr(0,3)
							// 	let a=value.substr(3,value.length)
							// 	// if(value == 'Mon'){
							// 	return b+`\n` + a;
							// 	// }
							// },
							// rich: {
							// 	//这里的rich，下面有解释
							// 	Mon: {
							// 		//这里的warnValue对应上面的标签名
							// 		height: 10,
							// 		align: 'center',
							// 		backgroundColor: {
							// 			image: "@/assets/echartsImg/et.png" //这个warnImg是上面定义的图片var warnImg = "img/warn.png";
							// 		}
							// 	}
							// }
						}
					},
					yAxis: {
						show: false
					},
					series: [{
						data: data.array,
						type: 'bar',
						itemStyle: {
							color: '#55aa7f'
						},
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function () {
					myChart.resize()
				}
			},
			async onAgeSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getAgeGroupList"
				//这里直接调用网络接口
				await util.post(url, {},
					function (result) {
						setTimeout(() => {
							that.initAges(result.data.list)
							that.initBar({
								groups: result.data.groups,
								array: result.data.array
							})
						}, 800)
					},
				);
			},
			async onNSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getSexGroupList"
				//这里直接调用网络接口
				await util.post(url, {},
					function (result) {
						setTimeout(() => {
							that.initAge(result.data.list)
						}, 800)
					},
				);
			},
			async ageSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getAgeGroupData"
				//这里直接调用网络接口
				await util.post(url, {},
					function (result) {
						setTimeout(() => {
							that.listAgeObj = result.data.list
							that.initBt(result.data.list)
						}, 800)
					},
				);
			}

		}
	}
</script>
<style lang="less">
	@import url("../../../../assets/css/order.css");
	@import url("../../../../assets/css/listboxless.less");
</style>
<style lang="less" scoped="scoped">
	.main {
		// height: calc(100vh - 44px);
		overflow: hidden;
		background: linear-gradient(to bottom, #00557f 30%, #0072a7);

		.tbox {
			padding: 10px;

			.tbox-list {
				margin: 0 25px;
			}
		}

		.datalist,
		.wl {
			margin: 20px 10px;
			padding: 10px;
			// border: 1px solid #000;
			border-radius: 10px;
			box-shadow: 2px 2px 10px #fafafa;

		}

		.datalist {
			text-align: center;
			//line-height: 25px;
			color: #fff;

			.ii span {
				color: #ffaa00;
				font-weight: 600;
				font-size: 18px;
				padding: 0 10px;
				letter-spacing: 3px;
			}
		}

		.wl {
			height: calc(100% - 260px);

			.scroll {
				height: calc(100% - 50px);
				overflow-y: scroll;
				overflow-x: hidden;
        margin: 0 25px;
			}

			.scroll::-webkit-scrollbar {
				display: none;
			}

			p {
				text-align: center;
				padding: 10px;
				color: #fff;
				font-size: 20px;
			}
		}

		.header-title {
			padding: 10px;
			text-align: center;
			color: #fff;
			text-shadow: 3px 5px 5px #656B79;

			h1 {
				font-size: 18px;
			}

			h3 {
				padding-top: 6px;
				font-size: 16px;
			}
		}

		.flex {
			display: flex;
			justify-content: space-between;
			padding: 3px 0 0 0;

			.l-date {
				color: #00abfa;
			}

			.r-num {
				font-size: 16px;
				color: #ffff7f;
			}
		}
	}
</style>
